import React from 'react'
import { shallow } from 'enzyme'
import { DocumentBucketModal } from '../../modals/DocumentBucketModal'

describe('DocumentBucketModal', () => {
  let wrapper, props

  const docProps = {
    bankEditable: false,
    referenceFiles: "[]",
    fileUrls: [
      {
        filename: 'one',
        link: '/link'
      }
    ]
  }

  const oc = {
    borrowerType: 'oc',
    name: 'OC',
    rid: 1,
    __typename: 'Business',
    corporateGuarantors: []
  }

  beforeAll( () => {
    props = {
      getMomentDate: true,
      categories: ['one'],
      customerService: false,
      bankAdmin: false,
      isAffiliate: false,
      entityId: 1,
      resourceType: 'Business',
      loan: {
        flowVariant: 'five_phase_multiproduct_sba_data_docs',
        multiproductFlow: true,
        businesses: [oc]
      },
      guarantors: [],
      document: {
        ...docProps,
        files: [{name: 'one'}]
      },
      entity: oc
    }
    wrapper = shallow(<DocumentBucketModal {...props} />)
  })

  describe('#renderTableFiles', () => {
    // renderTableFiles = () =>
    it('should return obj', () => {
      const obj = wrapper.instance().renderTableFiles()
      expect(typeof obj).toBe('object')
    })

    it('should render title for files', () => {
      const files = wrapper.find('DocumentBucketModal__Form').find('DocumentBucketModal__FilesTitle')
      expect(files).toHaveLength(1)
    })

    it('should render files', () => {
      const files = wrapper.find('DocumentBucketModal__Form').find('DocumentBucketModal__Files')
      expect(files).toHaveLength(1)
    })

    it('should not render files component if no files', () => {
      wrapper.setProps({
        document: {
          ...docProps,
          files: []
        }
      })
      const files = wrapper.find('DocumentBucketModal__Form').find('DocumentBucketModal__Files')
      expect(files).toHaveLength(0)
    })

  })

  describe('#fileUrl', () => {
    // renderTableFiles = () =>
    it('should return link', () => {
      const link = wrapper.instance().fileUrl('one')
      expect(typeof link).toBe('string')
      expect(link).toBe('/link')
    })
  })

  describe('#_isMultiproduct', () => {
    it('should return boolean: true', () => {
      const { _isMultiproduct } = wrapper.instance()
      expect(_isMultiproduct).toBeTruthy()
    })
    it('should return boolean: false', () => {
      props.loan.multiproductFlow = false
      wrapper.setProps({ ...props })
      const { _isMultiproduct } = wrapper.instance()
      expect(_isMultiproduct).toBeFalsy()
    })
  })
})
